import axios from 'axios';
const _base_uri = process.env.REACT_APP_API_URL

const httpClient = axios.create({
    baseURL: _base_uri,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
    timeout: 20000
});

const protectedClient = axios.create({
    baseURL: _base_uri,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
    timeout: 20000,
});

export { httpClient, protectedClient };